import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ContactModel, EContactType} from '../../../@models';
import {NbToastrService} from '@nebular/theme';

@Component({
  selector: 'ngx-form-list-contact',
  templateUrl: './form-list-contact.component.html',
  styleUrls: ['./form-list-contact.component.scss'],
})

export class FormListContactComponent implements OnInit, OnChanges {
  @Input() value: ContactModel[];
  @Output() valueChange: EventEmitter<ContactModel[]> = new EventEmitter<ContactModel[]>();


  newContact: ContactModel = new ContactModel();

  selected: ContactModel;
  options: { id: string, name: string }[][] = [];

  public contactTypes = EContactType;

  showAddressName = false;

  constructor(private toastrService: NbToastrService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.value && changes.value.currentValue) {
      this.options = [];
      changes.value.currentValue.forEach(el => {
        if (!this.options[el.type]) this.options[el.type] = [];
        this.options[el.type].push({ id: el._id, name: el.title });
      })
      if (this.options[EContactType.General]) this.select(this.options[EContactType.General][0].id)
      // console.log('contact types', this.contactTypes);
    }
  }

  ngOnInit() {
  }

  updateValue(value: ContactModel[]) {
    // console.log('update value', value)
    this.valueChange.emit(value);
  }

  addContact() {
    if (this.value == null) this.value = [];
    this.value.push(this.newContact);
    this.selected = this.newContact;
    this.newContact = new ContactModel();
  }

  onTypeChange(type) {
    if (+type === EContactType.General && this.value && this.value.find(f => f.type === EContactType.General)) {
      this.newContact.type = null;
      this.toastrService.warning('General contact already specified', 'Warning');
    }
    this.showAddressName = +type === EContactType.Delivery
    || +type  === EContactType.Invoice
    || +type === EContactType.Legal
    || +type === EContactType.PickUp;

    // console.log('type change', type, this.newContact, this.showAddressName);
  }

  select(id: string) {
    this.selected = this.value.find(f => f._id === id);
    // console.log('on select', this.selected)
  }


  /*
  removeElement(element: ContactModel) {
    const idx = this.value.indexOf(element);
    if (idx >= 0) {
      this.value.splice(idx, 1);
      this.updateValue(this.value);
    }
  }*/
}
